import { ProductList } from "../fragments.logistics/ProductList";
import { ProductFilter } from "../fragments.logistics/ProductFilter";
import { ProductForm } from "../fragments.logistics/ProductForm";
import { ProductTariffForm } from "../fragments.logistics/ProductTariffForm";
import { Card } from "../../../components/ui";
import React, { useState, useEffect } from "react";
import {
    fetchedProducts,
    fetchedBrands,
    fetchedUnits,
    fetchedGroupOfProducts,
} from "../../../apis/apis.logistics/apisProduct";

const initialProductTariffState = {
    productTariffID: "0",
    productID: "0",
    productSaleName: "",
    unitID: "0",
    unitName: "",
    priceSale: "",
    pricePurchase: "",
    percentageDiscount: "",
    quantityMinimum: "",
};

export function ProductPage() {
    const [units, setUnits] = useState([]);
    const [products, setProducts] = useState([]);
    const [prices, setPrices] = useState([]);
    const [itemProduct, setItemProduct] = useState({});
    const [itemProductTariff, setItemProductTariff] = useState(
        initialProductTariffState,
    );
    const [brands, setBrands] = useState([]);
    const [groupOfProducts, setGroupOfProducts] = useState([]);
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);
    const [isTariffModalOpen, setIsTariffModalOpen] = useState(false);

    const openProductModal = (product) => {
        setItemProduct(product);
        setIsProductModalOpen(true);
    };

    const closeProductModal = () => {
        setIsProductModalOpen(false);
    };

    const openTariffModal = (tariff) => {
        setItemProductTariff(tariff);
        setIsTariffModalOpen(true);
        let product = products.find((p) => p.productID === tariff.productID);
        setItemProduct(product);
    };

    const closeTariffModal = () => {
        setIsTariffModalOpen(false);
    };

    const [filters, setFilters] = useState({
        code: "",
        purchaseName: "",
        saleName: "",
        sku: "",
        productBrandName: "",
        priceSale: "",
        available: "true",
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleFilterChangeForAutocomplete = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    // Filtrar los productos en función de los filtros seleccionados
    const filteredProducts = products.filter((product) => {
        return (
            (filters.code === "" ||
                (product.code?.toString() || "").includes(filters.code)) &&
            (filters.purchaseName === "" ||
                (product.purchaseName.toLowerCase() || "").includes(
                    filters.purchaseName.toLowerCase(),
                )) &&
            (filters.saleName === "" ||
                (product.saleName?.toLowerCase() || "").includes(
                    filters.saleName?.toLowerCase(),
                )) &&
            (filters.sku === "" || (product.sku || "").includes(filters.sku)) &&
            (filters.productBrandName === "" ||
                (product.productBrandName || "").includes(
                    filters.productBrandName,
                )) &&
            (filters.priceSale === "" ||
                product.productTariffList.some(
                    (tariff) =>
                        !filters.priceSale ||
                        Number(tariff.priceSale) === Number(filters.priceSale),
                )) &&
            (filters.available === "" ||
                product.available === (filters.available === "true"))
        );
    });

    // Obtener valores únicos para los selectores
    const getUniqueValues = (key) => {
        return [...new Set(products.map((product) => product[key]))];
    };

    const getProducts = async () => {
        try {
            const dataProducts = await fetchedProducts();
            const isUnitTariff = (tariff) => tariff.unitID === 1;
            const dataPrices = dataProducts
                .filter((p) => p.productTariffList.length === 2)
                .map((p) => {
                    const unitTariff = p.productTariffList.find(isUnitTariff);
                    return unitTariff ? unitTariff.priceSale : null;
                })
                .filter((price) => price !== null);

            const uniquePrices = Object.keys(
                dataPrices.reduce(
                    (acc, curr) => ({ ...acc, [curr]: true }),
                    {},
                ),
            );
            const sortedPrices = uniquePrices.map(Number).sort((a, b) => a - b);
            setPrices(sortedPrices);
            setProducts(dataProducts);
            return dataProducts;
        } catch (error) {
            throw error;
        }
    };

    const getGroupOfProducts = async () => {
        try {
            const response = await fetchedGroupOfProducts();
            setGroupOfProducts(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getBrands = async () => {
        try {
            const response = await fetchedBrands();
            setBrands(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getUnits = async () => {
        try {
            const response = await fetchedUnits();
            setUnits(response);
            return response;
        } catch (error) {
            throw error;
        }
    };
    useEffect(() => {
        getProducts();
        getBrands();
        getUnits();
        getGroupOfProducts();
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                                Modulo Logístico
                            </h1>
                        </div>
                        <div>
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">
                                    <a href="#">Logística</a>
                                </li>
                                <li className="text-gray-500 dark:text-gray-400">
                                    /
                                </li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Productos
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4">
                    <Card className="shadow-md">
                        <ProductFilter
                            filters={filters}
                            handleFilterChange={handleFilterChange}
                            handleFilterChangeForAutocomplete={
                                handleFilterChangeForAutocomplete
                            }
                            getUniqueValues={getUniqueValues}
                            products={products}
                            prices={prices}
                        />
                        <ProductList
                            filteredProducts={filteredProducts}
                            onOpenProductModal={openProductModal}
                            onOpenTariffModal={openTariffModal}
                        />
                        <ProductForm
                            isOpen={isProductModalOpen}
                            onClose={closeProductModal}
                            itemProduct={itemProduct}
                            products={products}
                            brands={brands}
                            groupOfProducts={groupOfProducts}
                            getGroupOfProducts={getGroupOfProducts}
                            setProducts={setProducts}
                            getProducts={getProducts}
                        />
                        <ProductTariffForm
                            isOpen={isTariffModalOpen}
                            onClose={closeTariffModal}
                            units={units}
                            products={products}
                            itemProductTariff={itemProductTariff}
                            setItemProductTariff={setItemProductTariff}
                            setProducts={setProducts}
                            initialProductTariffState={
                                initialProductTariffState
                            }
                            itemProduct={itemProduct}
                        />
                    </Card>
                </div>
            </section>
        </>
    );
}

/*
              
              

*/
